export default function ActionText({
  actionText,
  actionCallback,
  dismissible,
}) {
  if (actionText.length) {
    return (
      <>
        <button
          className="lds-button-base lds-toast-action lds-toast-actionable-button"
          onClick={actionCallback}
        >
          {actionText}
        </button>
        {dismissible ? <div className="lds-toast-action-sep" /> : ''}
      </>
    );
  }
  return null;
}
